// src/components/LoginScreen.jsx
import React from "react";
import { Plane } from "lucide-react";

const USERS = ["Emily", "Candy", "Amy", "Cindy", "Max"];

export default function LoginScreen({ onLogin }) {
  return (
    <div className="min-h-screen bg-warm-paper flex flex-col items-center justify-center p-6 relative overflow-hidden">
      {/* 背景裝飾 */}
      <div className="absolute top-[-10%] right-[-10%] w-64 h-64 bg-gold/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-[-10%] left-[-10%] w-64 h-64 bg-starbucks/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="text-center mb-12 relative z-10">
        <div className="inline-block p-5 rounded-full bg-white shadow-warm mb-6 border border-gold/20">
          <Plane size={48} className="text-starbucks" />
        </div>
        <h1 className="text-4xl font-black text-starbucks-dark font-serif tracking-tight mb-2">
          Winter in Osaka
        </h1>
        <p className="text-hojicha font-bold tracking-[0.2em] text-sm uppercase">
          2026.01.21 — 01.25
        </p>
      </div>

      <div className="w-full max-w-xs space-y-4 relative z-10">
        <p className="text-center text-xs font-bold text-gray-400 uppercase tracking-widest mb-6">
          Select Traveler
        </p>

        {USERS.map((user) => (
          <button
            key={user}
            onClick={() => onLogin(user)}
            className="w-full bg-white p-4 rounded-2xl shadow-sm border-2 border-transparent hover:border-starbucks/30 hover:shadow-md active:scale-95 transition-all flex items-center gap-4 group"
          >
            <div className="w-12 h-12 rounded-full bg-warm-paper text-starbucks-dark flex items-center justify-center font-serif font-black text-xl group-hover:bg-starbucks group-hover:text-white transition-colors border border-hojicha-light/20">
              {user.charAt(0)}
            </div>
            <span className="font-bold text-xl text-gray-700 group-hover:text-starbucks-dark">
              {user}
            </span>
          </button>
        ))}
      </div>

      <p className="absolute bottom-8 text-[10px] text-gray-300 font-mono">
        OSAKA TRIP APP v1.0
      </p>
    </div>
  );
}
